module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-11.35cdaf4f.jpg";